import React, { useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTable, useSortBy, useFlexLayout } from 'react-table';
import { useSticky } from 'react-table-sticky';
// import ScrollContainer from 'react-indiana-drag-scroll';
import DoubleScrollbar from 'react-double-scrollbar';
import { BsFillCaretUpFill, BsFillCaretDownFill } from 'react-icons/bs';
import './styles.scss';

import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min';
import { FaInfo } from 'react-icons/fa';
// Cria um getter de propriedade padrão
const defaultPropGetter = () => ({});

const EpTable = ({ tableData, columns, getCellProps = defaultPropGetter }) => {
  const defaultColumnsSize = useMemo(
    () => ({
      minWidth: 50,
      width: 160,
    }),
    [],
  );

  const tableContainer = document.querySelector('.table');

  if (tableContainer) {
    const tableParent = tableContainer.parentNode;
    tableParent.style.height = '540px';
    tableParent.style.overflow = 'auto';
  }

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data: tableData,
    defaultColumnsSize,
    initialState: {
      sortBy: [
        {
          id: 'regionName',
          desc: false,
        },
      ],
    },

  },
  useFlexLayout,
  useSticky,
  useSortBy);

  function resizeBrowser() {
    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
      const evt = document.createEvent('UIEvents');
      evt.initUIEvent('resize', true, false, window, 0);
      window.dispatchEvent(evt);
    } else {
      window.dispatchEvent(new Event('resize'));
    }
  }

  const handleHighlightRowOnClick = (row) => {
    const trElement = document.getElementById(`table__body-row--${row.id}`);
    const highlightElems = document.querySelectorAll('.table__body-row--clicked');

    highlightElems.forEach((el) => {
      el.classList.remove('table__body-row--clicked');
    });

    trElement.classList.add('table__body-row--clicked');
    setTimeout(() => {
      resizeBrowser();
    }, 1000);
  };

  useEffect(() => {
    const initializeOrUpdatePopovers = () => {
      const instances = [];
      document.querySelectorAll('[data-bs-toggle="popover"]').forEach((triggerEl) => {
        const existingPopover = bootstrap.Popover.getInstance(triggerEl);

        if (existingPopover) {
          existingPopover.setContent({
            '.popover-body': triggerEl.getAttribute('data-bs-content'),
          });
          instances.push(existingPopover);
        } else {
          const newPopover = new bootstrap.Popover(triggerEl, {
            trigger: 'hover',
            placement: 'top',
          });
          instances.push(newPopover);
        }
      });

      return instances;
    };

    const updatePopoverContent = () => {
      headerGroups.forEach((headerGroup) => {
        headerGroup.headers.forEach((column) => {
          if (column.helpText) {
            const triggerEl = document.querySelector(`[data-bs-toggle="popover"][data-bs-content="${column.helpText}"]`);
            if (triggerEl) {
              triggerEl.setAttribute('data-bs-content', column.helpText);
            }
          }
        });
      });
    };

    const popoverInstances = initializeOrUpdatePopovers();

    updatePopoverContent();

    return () => {
      popoverInstances.forEach(popover => popover.dispose());
    };
  }, [headerGroups]);

  return (
    // <ScrollContainer className="scroll-container" hideScrollbars="false" ignoreElements="span">
    <DoubleScrollbar>
      <table
        className="table table--sticky"
        {...getTableProps()}
      >
        <thead className="table-light table__head">
          {headerGroups.map(headerGroup => (
            <tr className="table__head-row" {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th
                  scope="col"
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                >
                  {column.render('Header')}

                  {/* Símbolo da ordenação de cada coluna */}
                  <span>
                    {/* eslint-disable-next-line no-nested-ternary */}
                    {column.isSorted
                      ? column.isSortedDesc
                        ? <BsFillCaretDownFill />
                        : <BsFillCaretUpFill />
                      : ''}
                  </span>
                  <br />
                  {column.helpText
                    ? (
                      <span
                        data-bs-toggle="popover"
                        data-bs-placement="top"
                        data-bs-content={column.helpText} // Passa o valor diretamente
                      >
                        <FaInfo
                          style={{
                            cursor: 'pointer', background: '#55b3db', color: '#fff', borderRadius: '20px', padding: '2px',
                          }}
                          size={14}
                        />
                      </span>
                    )
                    : ''}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody className="table__body" {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (

              <tr className="table__body-row" id={`table__body-row--${row.id}`} onClick={() => handleHighlightRowOnClick(row)} {...row.getRowProps()}>
                {row.cells.map(cell => (
                  <td
                    className="table__cell"
                    {...cell.getCellProps([
                      getCellProps && getCellProps(cell),
                    ])}
                  >
                    <div className="table__cell-content-wrapper">
                      {cell.render('Cell')}
                    </div>
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </DoubleScrollbar>
    // </ScrollContainer>
  );
};

export default EpTable;

EpTable.defaultProps = {
  tableData: [],
  hiddenColumns: [],
  getCellProps: cellInfo => cellInfo,
};

EpTable.propTypes = {
  tableData: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  hiddenColumns: PropTypes.arrayOf(PropTypes.string),
  getCellProps: PropTypes.func,
};
